import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicLayout from "./layouts/PublicLayout";
import Home from "./pages/Home";
import Venues from "./pages/Venues";
import VenuePage from "./pages/VenuePage";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import OwnerDashboard from "./pages/owner/Dashboard";
import VenueEditor from "./pages/owner/VenueEditor";
import OwnerReservations from "./pages/owner/Reservations";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminOwners from "./pages/admin/Owners";
import AdminBookings from "./pages/admin/Bookings";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <PublicLayout>
                <Home />
              </PublicLayout>
            }
          />
          <Route
            path="/venues"
            element={
              <PublicLayout>
                <Venues />
              </PublicLayout>
            }
          />
          <Route
            path="/u/:slug"
            element={
              <PublicLayout>
                <VenuePage />
              </PublicLayout>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route
            path="/owner"
            element={
              <ProtectedRoute roles={["owner"]}>
                <OwnerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/owner/venue"
            element={
              <ProtectedRoute roles={["owner"]}>
                <VenueEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/owner/reservations"
            element={
              <ProtectedRoute roles={["owner"]}>
                <OwnerReservations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute roles={["admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/accounts"
            element={
              <ProtectedRoute roles={["admin"]}>
                <AdminOwners />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/bookings"
            element={
              <ProtectedRoute roles={["admin"]}>
                <AdminBookings />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
